export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-background-200/40 rounded-lg border border-background-300/30 overflow-hidden">
          <div className="flex flex-col md:flex-row items-center">
            {/* Visual */}
            <div className="w-full md:w-1/2 p-8 md:p-10 flex justify-center">
              <div className="w-40 h-40 md:w-56 md:h-56 rounded-2xl bg-background-300/50 flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20minimalist%20movie%20app%20icon%20design%20with%20film%20reel%20and%20play%20button%2C%20dark%20background%20with%20golden%20accents%2C%20modern%20flat%20design%2C%20cinematic%20aesthetic%2C%20clean%20composition%2C%20no%20text&width=400&height=400&seq=app-movie-icon-01&orientation=squarish"
                  alt="五姑娘影院移动端入口"
                  title="五姑娘影院移动观影"
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>
            </div>

            {/* Text */}
            <div className="w-full md:w-1/2 p-6 md:p-10 md:pl-0 text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
                移动观影
              </h2>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                五姑娘影院完美适配手机与平板浏览器，无需下载APP即可享受全高清流畅观影。通勤路上、午休间隙、睡前时光，随时随地打开浏览器就能看大片。支持所有主流移动浏览器，自动适配屏幕尺寸，给您最佳的移动观影体验。
              </p>
              <div className="flex flex-wrap gap-3 justify-center md:justify-start">
                <span className="px-3 py-1.5 rounded-full bg-background-300/40 text-foreground-300 text-xs border border-background-300/40 whitespace-nowrap">
                  <i className="ri-smartphone-line mr-1"></i>手机观影
                </span>
                <span className="px-3 py-1.5 rounded-full bg-background-300/40 text-foreground-300 text-xs border border-background-300/40 whitespace-nowrap">
                  <i className="ri-tablet-line mr-1"></i>平板适配
                </span>
                <span className="px-3 py-1.5 rounded-full bg-background-300/40 text-foreground-300 text-xs border border-background-300/40 whitespace-nowrap">
                  <i className="ri-hd-line mr-1"></i>高清画质
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}